class ProductSwatches extends HTMLElement {
  constructor() {
    super();
    this.swatchesJson = theme.assets.swatches;
    this.init();
  }

  async init() {
    await this.fetchSwatches();
    const { colors } = this.swatchesData;

    const swatches = this.querySelectorAll('.swatch-button');
    for (const swatch of swatches) {
      const label = swatch.getAttribute('data-label');
      const color = colors.find((color) => {
        return color[label] || color[label.toLowerCase()];
      });

      if (color) {
        let background = color[label] || color[label.toLowerCase()];
        if (background.includes('.')) {
          background = `url(${theme.assets.base}${background})`;
        }
        swatch.style.background = background;
      }
    }
  }

  async fetchSwatches() {
    const sessionSwatches = sessionStorage.getItem('swatches');
    if (sessionSwatches) {
      this.swatchesData = JSON.parse(sessionSwatches);
      return;
    } else {
      const response = await fetch(this.swatchesJson);
      const data = await response.json();
      this.swatchesData = data;
      sessionStorage.setItem('swatches', JSON.stringify(data));
    }
  }
}

customElements.define('product-swatches', ProductSwatches);
